import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse } from "@/lib/types/APIResponse";
import { type AppSubscription } from "@/lib/types/Firm";
import { baseFastApiFirmRoute } from "./firm";

export function getAppSubscriptionsV2() {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<AppSubscription[]>
    >(`${baseFastApiFirmRoute}/app-subscriptions`)
    .then((res) => res.data);
}

export function createAppSubscriptionV2(data: { appId: string }) {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<AppSubscription>
    >(`${baseFastApiFirmRoute}/app-subscriptions`, data)
    .then((res) => res.data);
}

export function deleteAppSubscriptionV2(data: { subscriptionId: string }) {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<AppSubscription>
    >(`${baseFastApiFirmRoute}/app-subscriptions/${data.subscriptionId}`)
    .then((res) => res.data);
}
